export default __webpack_public_path__ + "static/gallery-award-big-w-2d1fe5815fb036d05a46ec8e14fc8092.png";